import React, { useId } from 'react';
import PropTypes from 'prop-types';
import './RecordLicense.css';
import FormElementHeader from '../form/FormElementHeader';
import { Col, Container, Row } from 'react-bootstrap';
import RadioButtonGroup from '../form/RadioButtonGroup';
import { useTranslation } from 'react-i18next';
import {DEFAULT_LICENSES} from '../../Constants.js';
import HelpDialog from "../dialog/HelpDialog";

const RecordLicense = ({ license, onChange, message, disabled = false }) => {
  const { t } = useTranslation();
  const id = useId();


  const licenses = [
    ...DEFAULT_LICENSES
  ];

  const asOption = (license) => {
      return { value: license, label: t(license) };
  };

  const handleChange = (selected) => {
    onChange(selected);
  };


  return (
    <Container>
      <Row>
        <Col>
          <FormElementHeader 
            id={id}
            helpDialog={(
              <HelpDialog label={t('record_license_help_label')} >
                {t('record_license_help_content')}
              </HelpDialog>
            )}
            required
          >
            {t('record_license_header')}
          </FormElementHeader>
        </Col>
      </Row>
      <Row>
        <Col>
          <RadioButtonGroup
              options={licenses.map(asOption)}
              value={license}
              onChange={handleChange}
              disabled={disabled}
              aria-required
              message={message}
          />
        </Col>
      </Row>
    </Container>
  );
};

RecordLicense.propTypes = {
  license: PropTypes.string.isRequired,
  message: PropTypes.shape({
    content: PropTypes.string,
    type: PropTypes.oneOf(['light', 'neutral', 'warning'])
  }),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default RecordLicense;
